// @ts-check
import { get_custom_fields, get_incident_options } from '~/api/zero-api';
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext, useEffect, useMemo, useState } from "react";

/**
 * @typedef {defaultIncidentOptions} IncidentOptions
 */

export const [IncidentDataGridContext, IncidentDataGridContextProvider] = createDataGridContext('incidents', useContextValue);

export function useIncidentDataGridContext() {
    return useContext(IncidentDataGridContext);
}

const defaultIncidentOptions = {
    body_front_parts: [],
    body_back_parts: [],
    case_classifications: [],
    incident_types: [],
    incident_causes: [],
    event_types: [],
    incident_illnesses: [],
    incident_injuries: [],
    sex: [],
};

function useContextValue() {
    const [incidentOptions, setIncidentOptions] = useState(defaultIncidentOptions);
    const [customFields, setCustomFields] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadOptions = async () => {
            try {
                const res = await get_incident_options();
                const { data } = await res.json();
                setIncidentOptions(data);
            } catch (err) {
                console.error("Could not load incident options");
            }
        };

        const loadCustomFields = async () => {
            try {
                const res = await get_custom_fields();
                const customFields = await res.json();
                setCustomFields(customFields);
            } catch (err) {
                console.error("Could not load incident custom fields");
            }
        };

        Promise.all([loadOptions(), loadCustomFields()]).then(() => {
            setIsLoading(false);
        });
    }, []);

    return useMemo(() => ({
        incidentOptions,
        customFields,
        isLoading,
    }), [incidentOptions, customFields, isLoading]);
}